import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import knowledgeService from "../../../services/knowledgeService";
import imageUpload from "../../../services/upload";
import { TextField, FormHelperText } from "@mui/material";
import RichTextEditor from "react-rte";
import { IMAGE_PATH, instanceToken } from "../../../utils/constant";
import { Controller, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { createNewKnowledgeSchema } from "../../../schema/createNewKnowledgeSchema";
import {
  EditPageLayout,
  EditImageSection,
  EditFieldLabel,
  EditFormTopSection,
  EditFormParagraphsSection,
} from "../../../components/edit/EditPageLayout";

const imgFileTypes = ["image/gif", "image/jpeg", "image/png", "image/svg+xml"];

const UpdateKnowledge = ({ homeAlert }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [imagePreview, setImagePreview] = useState("");
  const [imageFile, setImageFile] = useState("");
  const [imageFileUrl, setImageFileUrl] = useState("");
  const [values, setValues] = useState({ image_url: "" });
  const [titleEng, setTitleEng] = useState("");
  const [titleMM, setTitleMM] = useState("");
  const [parEng, setParEng] = useState(RichTextEditor.createEmptyValue());
  const [parMM, setParMM] = useState(RichTextEditor.createEmptyValue());
  const [errorMessage, setErrorMessage] = useState({});

  const [knowledge, setknowledge] = useState(null);

  const {
    register,
    handleSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(createNewKnowledgeSchema),
    initialValues: {
      title_en: "",
      title_mm: "",
      paragraph_en: "<p></p>",
      paragraph_mm: "<p></p>",
    },
  });

  async function getImageUrl(imgData) {
    const response = await imageUpload.getImageUrl(
      instanceToken.token,
      imgData
    );
    const result = response.data;
    console.log(result);
    const path = IMAGE_PATH + result?.imageName;
    console.log("path=============>", path);
    setImageFileUrl(result?.imageUploadUrl);
    setValues({
      ...values,
      image_url: path,
    });
  }
  useEffect(() => {
    if (!knowledge) {
      fetchknowledge();
    }
  }, []);

  useEffect(() => {
    setTitleEng(knowledge?.title_en);
    setTitleMM(knowledge?.title_mm);
    setParEng(
      RichTextEditor.createValueFromString(knowledge?.paragraph_en, "html")
    );
    setParMM(
      RichTextEditor.createValueFromString(knowledge?.paragraph_mm, "html")
    );

    if (knowledge) {
      setValue("title_en", knowledge?.title_en);
      setValue("title_mm", knowledge?.title_mm);
      setValue("paragraph_en", knowledge?.paragraph_en);
      setValue("paragraph_mm", knowledge?.paragraph_mm);

      setValues({
        image_url: knowledge?.image_url || "",
      });
    }
  }, [knowledge, setValue]);

  const fetchknowledge = async () => {
    try {
      const res = await knowledgeService.getKnowledge(instanceToken.token, id);
      setknowledge(res.data);
    } catch (error) {
      console.error(error);
      throw new Error(error);
    }
  };

  const changeTitleMM = (e) => {
    setTitleMM(e.target.value.trim());
  };
  const changeTitleEng = (e) => {
    setTitleEng(e.target.value.trim());
  };

  //   const handleParagraphEng = (value) => {
  //     const cleanedText = value.toString('html').replace(/<[^>]+>/g, '').trim(); // Remove HTML tags
  //     setParEng(value);
  //     setValue('paragraph_en', cleanedText);
  // };

  // const handleParagraphMM = (value) => {
  //   const cleanedText = value.toString('html').replace(/<[^>]+>/g, '').trim();
  //   setParMM(value);
  //   setValue('paragraph_mm', cleanedText);
  // };

  const changeFile = async (e) => {
    if (e.target.files && e.target.files[0]) {
      const img = e.target.files[0];
      if (!imgFileTypes.includes(img.type)) {
        setErrorMessage({
          ...errorMessage,
          profile: "Please select image. (PNG, JPG, JPEG, GIF, ...)",
        });
        return;
      }
      if (img.size > 10485760) {
        setErrorMessage({
          ...errorMessage,
          profile: "Image file size must be smaller than 10MB.",
        });
        return;
      }
      setImageFile(img);
      setImagePreview(URL.createObjectURL(img));
      getImageUrl(img);
    }
  };

  const formData = new FormData();

  const handleUpdate = async (data) => {
    formData.append("title_en", data?.title_en);
    formData.append("title_mm", data?.title_mm);
    formData.append("paragraph_en", data?.paragraph_en);
    formData.append("paragraph_mm", data?.paragraph_mm);
    formData.append(
      "image_url",
      values?.image_url ? values?.image_url : data?.image_url
    );
    formData.append("image_data", "");

    try {
      setLoading(true);
      console.log(formData);
      if (imageFile) {
        await imageUpload.uploadImage(imageFileUrl, imageFile);
      }
      const response = await knowledgeService.putKnowledge(
        instanceToken.token,
        knowledge?.id,
        formData
      );
      navigate("/knowledges");
      console.log("response ", response);
      setknowledge(response.data);
      homeAlert("knowledge Post have been updated.", false);
    } catch (error) {
      console.log(error);
      homeAlert("Error on server.", true);
    } finally {
      setLoading(false);
      setErrorMessage({});
    }
  };

  const handleRemove = async () => {
    try {
      await knowledgeService.deleteKnowledge(instanceToken.token, id);
      homeAlert("Knowledge post have been removed.", false);
      navigate("/knowledges");
    } catch (error) {
      console.log(error);
      homeAlert("Error on server!", true);
    }
  };

  return (
    <EditPageLayout
      title="Edit Knowledge Post"
      subtitle="Update your knowledge post details and content in both languages."
      breadcrumbs={[
        { label: "Knowledges", path: "/knowledges" },
        { label: `Knowledge (ID - ${id})`, path: `/knowledges/${id}` },
        { label: "Edit" },
      ]}
      detailPath={`/knowledges/${id}`}
      onRemove={handleRemove}
      loading={loading}
      onSubmit={handleSubmit(handleUpdate)}
      removeMessage="Are you sure you want to remove this knowledge post?"
    >
      <EditFormTopSection
        image={
          <EditImageSection
            uploadLabel="Knowledge Image"
            previewLabel="Image Preview"
            imageUrl={values?.image_url}
            imagePreview={imagePreview}
            onFileChange={changeFile}
            error={errorMessage["image_url"] || errorMessage["profile"]}
          />
        }
      >
        <div>
          <EditFieldLabel required>Title (English)</EditFieldLabel>
          <TextField
            fullWidth
            id="title_en"
            {...register("title_en")}
            onChange={changeTitleEng}
            value={titleEng}
            error={!!errors.title_en}
            helperText={errors.title_en?.message}
          />
        </div>
        <div>
          <EditFieldLabel required>Title (Myanmar)</EditFieldLabel>
          <TextField
            fullWidth
            id="title_mm"
            {...register("title_mm")}
            onChange={changeTitleMM}
            value={titleMM}
            error={!!errors.title_mm}
            helperText={errors.title_mm?.message}
          />
        </div>
      </EditFormTopSection>

      <EditFormParagraphsSection>
        <div className="edit-editor-field">
          <EditFieldLabel required>Paragraph (English)</EditFieldLabel>
          <Controller
            name="paragraph_en"
            control={control}
            render={() => (
              <>
                <RichTextEditor
                  value={parEng}
                  onChange={(value) => {
                    setParEng(value);
                    setValue(
                      "paragraph_en",
                      value
                        .toString("html")
                        .replace(/<[^>]*>/g, "")
                        .trim()
                    );
                  }}
                />
                {errors.paragraph_en && (
                  <FormHelperText error>
                    {errors.paragraph_en.message}
                  </FormHelperText>
                )}
              </>
            )}
          />
        </div>

        <div className="edit-editor-field">
          <EditFieldLabel required>Paragraph (Myanmar)</EditFieldLabel>
          <Controller
            name="paragraph_mm"
            control={control}
            render={() => (
              <>
                <RichTextEditor
                  value={parMM}
                  onChange={(value) => {
                    setParMM(value);
                    setValue(
                      "paragraph_mm",
                      value
                        .toString("html")
                        .replace(/<[^>]*>/g, "")
                        .trim()
                    );
                  }}
                />
                {errors.paragraph_mm && (
                  <FormHelperText error>
                    {errors.paragraph_mm.message}
                  </FormHelperText>
                )}
              </>
            )}
          />
        </div>
      </EditFormParagraphsSection>
    </EditPageLayout>
  );
};

export default UpdateKnowledge;
